import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ShowHideApplicationHeaderService {
private isHeaderVisible = true;

  constructor() { }

  public showHeader() {
    this.isHeaderVisible = true;
  }

  public hideHeader() {
    this.isHeaderVisible = false;
  }

  public isVisible() {
    return this.isHeaderVisible;
  }
}
